export interface IEditUser {
  firstName: string;
  lastName: string;
  phoneCountryCode: string;
  phoneNumber: string;
  position?: string;
  phoneExtension?: string;
  address1: string;
  address2?: string;
  country: string;
  city: string;
  postalCode: string;
  documentType: DocumentType;
  documentNumber: string;
  agencyId?: string;
}

export enum DocumentType {
  PASSPORT = 'PASSPORT',
  DNI = 'DNI',
  CI = 'CI',
}

export type AuthScreens = 'login' | 'register' | 'forgot-password' | 'reset-password' | 'code-reset';
